import { useEffect, useState } from 'react';
import { Link, useSearchParams } from 'react-router-dom';
import { ApiError, userAuth } from '../api.js';

export function VerifyEmailPage() {
  const [search] = useSearchParams();
  const token = search.get('token');
  const [state, setState] = useState<'loading' | 'ok' | 'bad'>('loading');
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    if (!token) {
      setState('bad');
      setError('No verification token provided.');
      return;
    }
    void userAuth.verifyEmail(token).then(
      () => setState('ok'),
      (err) => {
        setState('bad');
        setError(err instanceof ApiError ? err.message : 'Verification failed.');
      },
    );
  }, [token]);

  return (
    <div className="max-w-sm mx-auto py-16 text-center">
      {state === 'loading' && <p className="text-muted">Verifying…</p>}
      {state === 'ok' && (
        <>
          <h1 className="font-serif text-3xl mb-2">Email verified</h1>
          <p className="text-muted text-sm mb-6">
            Your email is now confirmed.
          </p>
          <Link to="/projects" className="text-accent underline-offset-2 hover:underline text-sm">Go to projects →</Link>
        </>
      )}
      {state === 'bad' && (
        <>
          <h1 className="font-serif text-3xl mb-2">Could not verify</h1>
          <p className="text-muted text-sm mb-6">{error}</p>
          <Link to="/projects" className="text-accent underline-offset-2 hover:underline text-sm">Go to projects →</Link>
        </>
      )}
    </div>
  );
}
